import { ICellRenderer } from "ag-grid-enterprise";
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";

@Component({
    selector: 'activity-name--cell-renderer',
    templateUrl: 'activity-name-cell-renderer.component.html',
    styleUrls: ['./activity-name-cell-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityNameCellRendererComponent implements ICellRenderer  {
  params!: any;
  public activityName = signal<string>('');
  public tooltip = signal<string>('');

  agInit(params: any): void {
    this.params = params;
    this.setParameters();
  }

  setParameters() {
    this.activityName.set(this.params.data?.activityName);

    if (this.params.data?.modifiedByFullName != null && this.params.data?.modifiedDate != null) {
        this.tooltip.set(`Last Modified by ${this.params.data.modifiedByFullName} on ${new Date(this.params.data.modifiedDate).toLocaleString()}`);
    }
  }

  refresh(params: any) {
    this.params = params;
    this.setParameters();
    return true;
  }
}
